import { render, staticRenderFns } from "./SuperTerminalDataUsage.vue?vue&type=template&id=81e19758&scoped=true&"
import script from "./SuperTerminalDataUsage.vue?vue&type=script&lang=ts&"
export * from "./SuperTerminalDataUsage.vue?vue&type=script&lang=ts&"
import style0 from "./SuperTerminalDataUsage.vue?vue&type=style&index=0&id=81e19758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e19758",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VDataTable,VFlex,VLayout})
